export default {
    tickets: [
        { id: 1, status: 'new', note: 'Sans sucre' },
        { id: 2, status: 'preparing', note: 'dans 10 minutes' },
        { id: 3, status: 'completed' },
        { id: 4, status: 'new' },
        { id: 5, status: 'new' },
        { id: 6, status: 'new' },
    ]
}